import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SignInRoutingModule } from './sign-in-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SignInRoutingModule
  ]
})
export class SignInModule { }

/**
 * Modal for Sign In  Response
 */
export class MSignInResponse {
  statusCode!: number;
  message!: string;
  totalRecords!: number;
  data!: MSignInResponseData;
  token!: string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for Sign In  Response Data 
 */
export class MSignInResponseData {
  phone_number!: number;
  id!: string;
  type_id!: number;
  role_permissions_id?: string
  username!: any
  first_name!: string
  last_name!: string
  dob!: string
  is_phone_number_verified!: any
  alternet_phone_number!: any
  email!: string
  is_email_verified!: any
  gender!: number
  is_active!: boolean
  is_deleted!: boolean
  last_login_at!: any
  device_type!: any
  fcm_token!: any
  google_id!: any
  fb_id!: any
  is_subscribed!: boolean
  created_by!: string
  modified_by!: string
  created_at!: string
  modified_at!:string
  userMessage!: string
  accessToken!: string
  role_pattern!: any
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for Sign In  Request
 */
export class MSignInRequest {
  phone_number!: number;
}
